module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.req.type == 'CoreRequirement') ? _c('div', {
    staticClass: "coreinfo"
  }, [_c('requirement', {
    ref: "coreRequirement",
    attrs: {
      "req": _vm.req.core
    }
  })], 1) : _c('div', {
    staticClass: "requirement"
  }, [(_vm.req.type == 'DegreeRequirement') ? _c('degree-requirement', {
    ref: "degreeRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e(), _vm._v(" "), (_vm.req.type == 'CourseRequirement') ? _c('course', {
    ref: "courseRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e(), _vm._v(" "), (_vm.req.type == 'WildCardRequirement') ? _c('wildcard', {
    ref: "wildCardRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32543aaf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requirement.vue
// module id = 1121
// module chunks = 1